const paymentTypes = {
  ecommerce: 'order',
  subscription: 'subscription',
  subscriptionAndEcommerce: 'subscriptionAndEcommerce',
  giftSubscription: 'giftSubscription',
  giftSubscriptionRedeem: 'giftSubscriptionRedeem',
  coupon: 'coupon',
  giftCard: 'giftCard',
  giftRedeem: 'giftRedeem',
  updateInfo: 'updateInfo',
}


export default paymentTypes
